import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const SignatureElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Signature Pad',
  icon: 'BadgeCheckIcon',
  description:
    'Adds a signature pad field that can be used to sign and store the signature image on the record',

  properties: [
    'layout',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Signature Field',
      name: 'signatureField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The field from the underlying record that will be used to store the url to the Signature image in firebase storage.',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      }
    },
    {
      label: 'Acceptance Status Field',
      name: 'acceptanceField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'A field that stores the status of whether the record has been accepted. When a signature is provided this field will be updated with the acceptance value provided.',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      }
    },
    {
      label: 'Acceptance Status Value',
      name: 'acceptanceValue',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The value to update the Acceptance Field with, when a signature is provided.',
      default: '',
      options: []
    },
    {
      label: 'Acceptance Date Field',
      name: 'dateField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'A field that stores the date that the signature was provided.',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      }
    },
    {
      label: 'Collection Path',
      name: 'collectionPath',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The path to the collection of the document containing the Signature',
      default: '',
      options: []
    },
    {
      label: 'Signature File Name',
      name: 'fileName',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description: 'The name to give the image file in firebase storage.',
      default: '',
      options: []
    },
    {
      label: 'Storage Path',
      name: 'storagePath',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The path in firebase storage to store the generated Signature image',
      default: '',
      options: []
    },
    {
      label: 'Use Original Image',
      name: 'useOriginalImage',
      editor: 'boolean',
      description:
        'If true, uses the original signature image that was generated instead of a signature thumbnail',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Image Width',
      name: 'width',
      editor: 'number',
      description: 'The width of the image',
      default: 80,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'image'
        }
      ]
    },
    {
      label: 'Image Height',
      name: 'height',
      editor: 'number',
      description: 'The height of the image',
      default: 80,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'image'
        }
      ]
    },
    {
      label: 'Spinner Color',
      name: 'spinnerColor',
      editor: 'color',
      description:
        'The color of the activity indicator during signature processing.',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Spinner Size',
      name: 'spinnerSize',
      editor: 'dropdown',
      description: 'The size of the signature spinner.',
      default: 'small',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Large', value: 'large' }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the signature has been stored',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Sign Button Text',
      name: 'signButtonText',
      description: 'The text to display on the sign button',
      editor: 'textbox',
      default: 'Save Signature',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Clear Button Text',
      name: 'clearButtonText',
      description: 'The text to display on the clear signature button',
      editor: 'textbox',
      default: 'Clear',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default SignatureElementFields;
